// extracted by mini-css-extract-plugin
module.exports = {"Custom":"CustomButton_Custom__1e0Aa","Thin":"CustomButton_Thin__3QOl8"};